import React from "react";
import { Alert, Icon, Button } from "antd";
import get from "lodash/get";

import { IBMReprocessing, ECOAReprocessing } from "../../api/requests";

import PatientImednetProcessing from "./PatientImednetProcessing";
import PatientDatafaxProcessing from "./PatientDatafaxProcessing";
import PatientRedcapProcessing from "./PatientRedcapProcessing";

import classes from "./PatientProfileForm.css";
import { withNamespaces } from "react-i18next";
import {
  getApiEcoaUpdatePermission,
  getApiIbmUpdatePermission,
  getApiImednetUpdatePermission,
  getApiDatafaxUpdatePermission,
  getRunRedcapApiConfigPermission,
  getRunDFDiscoverApiConfigPermission,
} from "../../reducers/user/selectors";
import { connect } from "react-redux";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class PatientIBMProcessing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSent: false,
      isEcoaSent: false,
      isLoading: false,
      isLoadingEcoa: false,
      requestResult: null,
      requestEcoaResult: null,
    };
  }

  handleSubmit = async () => {
    this.setState({ isLoading: true });
    try {
      await IBMReprocessing(this.props.subjectID);

      this.setState({
        isSent: true,
        requestResult: {
          type: "success",
          message: this.props.i18n.t(
            "NamespacePatientAPIControls:Request has been sent"
          ),
        },
      });
    } catch (e) {
      this.setState({
        requestResult: {
          type: "error",
          message: this.props.i18n.t("Error"),
        },
      });
    }

    this.setState({ isLoading: false });
  };

  handleEcoaSubmit = async () => {
    this.setState({ isLoadingEcoa: true });
    try {
      const { data } = await ECOAReprocessing(this.props.subjectID);
      console.log(data);

      this.setState({
        isEcoaSent: true,
        requestEcoaResult: {
          type: "success",
          message: get(
            data,
            "status",
            this.props.i18n.t(
              "NamespacePatientAPIControls:Request has been sent"
            )
          ),
        },
      });
    } catch (e) {
      this.setState({
        requestEcoaResult: {
          type: "error",
          message: get(
            e,
            "response.data.error",
            get(e, "response.data.status", this.props.i18n.t("Error"))
          ),
        },
      });
    }

    this.setState({ isLoadingEcoa: false });
  };

  render() {
    const { status_obj, ibm_api_data_changed, ecoa_subject } = this.props;

    const {
      isLoading,
      isLoadingEcoa,
      isSent,
      isEcoaSent,
      requestResult,
      requestEcoaResult,
    } = this.state;

    let statusType = "info";
    if (status_obj && status_obj.status) {
      if (status_obj.status === "COMPLETED") {
        statusType = "success";
      } else if (status_obj.status === "DECLINED") {
        statusType = "error";
      } else if (status_obj.status === "PENDING") {
        statusType = "info";
      } else if (status_obj.status === "IDLE") {
        statusType = "info";
      }
    }

    return (
      <div className={classes.patientProfileForm}>
        {status_obj && this.props.apiIbmUpdatePermission && (
          <div>

            {get(this.props.subject, "api_connections.data.ibm") && (
              <div>
                <h6 className="headline-default">
                  {this.props.i18n.t("IBM ID")}: {get(this.props.subject, "api_connections.data.ibm")}
                </h6>
              </div>
            )}

            {status_obj.comment && (
              <Alert
                message={status_obj.comment}
                type={statusType}
                style={{ width: "300px" }}
              />
            )}
            {ibm_api_data_changed && (
              <Alert
                message={ibm_api_data_changed}
                type="success"
                style={{ width: "300px", marginTop: "5px" }}
              />
            )}
            <br />
            <Button
              disabled={status_obj.status === "PENDING" || isSent}
              type="primary"
              size="large"
              htmlType="button"
              onClick={this.handleSubmit}
              className={classes.submitButton}
            >
              {this.props.i18n.t(
                "NamespacePatientAPIControls:IBM EDC API 1 Resend data"
              )}
              {isLoading && <Icon type="loading" />}
            </Button>
            <br />
            <br />
            {requestResult && (
              <Alert
                message={requestResult.message}
                type={requestResult.type}
                style={{ width: "300px" }}
              />
            )}
            <hr />
          </div>
        )}

        {status_obj && this.props.apiEcoaUpdatePermission && (
          <div>

            {get(this.props.subject_api_connections, "ecoa") && (
              <div>
                <h6 className="headline-default">
                  {this.props.i18n.t("ECOA ID")}: {get(this.props.subject_api_connections, "ecoa")}
                </h6>
              </div>
            )}

            <br />
            <Alert
              message={ecoa_subject || "Data was not sent"}
              type={ecoa_subject ? "success" : "warning"}
              style={{ width: "300px" }}
            />
            <br />
            <Button
              disabled={status_obj.status === "PENDING" || isEcoaSent}
              type="primary"
              size="large"
              htmlType="button"
              onClick={this.handleEcoaSubmit}
              className={classes.submitButton}
            >
              {this.props.i18n.t(
                "NamespacePatientAPIControls:Ecoa EDC API 1 Resend data"
              )}
              {isLoadingEcoa && <Icon type="loading" />}
            </Button>
            <br />
            <br />
            {requestEcoaResult && (
              <Alert
                message={requestEcoaResult.message}
                type={requestEcoaResult.type}
                style={{ width: "300px" }}
              />
            )}
            <hr />
          </div>
        )}

        {this.props.apiImednetUpdatePermission && (
          <div>
            {get(this.props.subject_api_connections, "imednet") && (
              <div>
                <h6 className="headline-default">
                  {this.props.i18n.t("DFDiscover ID")}: {get(this.props.subject_api_connections, "imednet")}
                </h6>
              </div>
            )}
            <PatientImednetProcessing subjectID={this.props.subjectID} />
            <hr />
            <br />
          </div>
        )}

        {this.props.getRunDFDiscoverApiConfigPermission && (
          <div>
            {get(this.props.subject_api_connections, "dfdiscover") && (
              <div>
                <h6 className="headline-default">
                  {this.props.i18n.t("DFDiscover ID")}: {get(this.props.subject_api_connections, "dfdiscover")}
                </h6>
              </div>
            )}
            {get(this.props, "subject_api_connections", null) &&
              (<span className={classes.apiConnectionGray}>{this.props.i18n.t("Api connections")}:{JSON.stringify(get(this.props, "subject_api_connections"))}</span>)
            }
            <PatientDatafaxProcessing subjectID={this.props.subjectID} />
            <hr />
            <br />
          </div>
        )}

        {this.props.getRunRedcapApiConfigPermission && (
          <div>
            {get(this.props.subject_api_connections, "redcap") && (
              <div>
                <h6 className="headline-default">
                  {this.props.i18n.t("RedCap ID")}: {get(this.props.subject_api_connections, "redcap")}
                </h6>
              </div>
            )}
            <PatientRedcapProcessing subjectID={this.props.subjectID} />
            <hr />
            <br />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  apiIbmUpdatePermission: getApiIbmUpdatePermission(state),
  apiEcoaUpdatePermission: getApiEcoaUpdatePermission(state),
  apiImednetUpdatePermission: getApiImednetUpdatePermission(state),
  apiDatafaxUpdatePermission: getApiDatafaxUpdatePermission(state),
  getRunRedcapApiConfigPermission: getRunRedcapApiConfigPermission(state),
  getRunDFDiscoverApiConfigPermission: getRunDFDiscoverApiConfigPermission(state),
});

export default connect(mapStateToProps)(withNamespaces()(PatientIBMProcessing));



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientIBMProcessing.js